import { z } from 'zod';
export const aiIssueCreateSchema = z.object({
    title: z.string().min(1).max(500),
    description: z.string().min(1),
    type: z.enum(['feature_request', 'bug', 'improvement', 'task']),
    priority: z.enum(['critical', 'high', 'medium', 'low']).optional().default('medium'),
    assignedTo: z.number().int().positive().optional(),
    assignedProfileId: z.number().int().positive().optional(),
    parentIssueId: z.number().int().positive().optional(),
    relatedFiles: z.array(z.string()).optional(),
    labels: z.array(z.number().int().positive()).optional(),
    metadata: z.record(z.unknown()).optional(),
    reviewProfileId: z.number().int().positive().optional(),
});
export const aiIssueUpdateSchema = z.object({
    title: z.string().min(1).max(500).optional(),
    description: z.string().min(1).optional(),
    type: z.enum(['feature_request', 'bug', 'improvement', 'task']).optional(),
    status: z.enum(['open', 'in_progress', 'review', 'resolved', 'closed', 'wontfix']).optional(),
    priority: z.enum(['critical', 'high', 'medium', 'low']).optional(),
    assignedTo: z.number().int().positive().nullable().optional(),
    assignedProfileId: z.number().int().positive().nullable().optional(),
    parentIssueId: z.number().int().positive().nullable().optional(),
    relatedFiles: z.array(z.string()).optional(),
    resolutionNote: z.string().optional(),
    metadata: z.record(z.unknown()).optional(),
});
export const aiIssueCommentCreateSchema = z.object({
    content: z.string().min(1),
    metadata: z.record(z.unknown()).optional(),
});
export const aiIssueLabelCreateSchema = z.object({
    name: z.string().min(1).max(100),
    color: z.string().regex(/^#[0-9a-fA-F]{6}$/).optional().default('#6366f1'),
    description: z.string().max(255).optional(),
});
export const aiIssueListQuerySchema = z.object({
    page: z.coerce.number().int().min(1).optional().default(1),
    perPage: z.coerce.number().int().min(1).max(100).optional().default(20),
    search: z.string().optional(),
    status: z
        .union([
        z.enum(['open', 'in_progress', 'review', 'resolved', 'closed', 'wontfix']),
        z.array(z.enum(['open', 'in_progress', 'review', 'resolved', 'closed', 'wontfix'])),
        z.string().transform((val) => val.split(',').map((s) => s.trim()).filter(Boolean)),
    ])
        .optional(),
    type: z.enum(['feature_request', 'bug', 'improvement', 'task']).optional(),
    priority: z.enum(['critical', 'high', 'medium', 'low']).optional(),
    labelId: z.coerce.number().int().positive().optional(),
    assignedProfileId: z.coerce.number().int().positive().optional(),
    assignedTo: z.coerce.number().int().positive().optional(),
    parentIssueId: z.coerce.number().int().positive().optional(),
    sortBy: z.enum(['created_at', 'updated_at', 'priority', 'title']).optional().default('created_at'),
    sortOrder: z.enum(['asc', 'desc']).optional().default('desc'),
});
export const aiIssueAssignSchema = z.object({
    assignedTo: z.number().int().positive().nullable().optional(),
    assignedProfileId: z.number().int().positive().nullable().optional(),
});
//# sourceMappingURL=aiIssue.schema.js.map